<div class="main-wrapper">
  <div class="container">
    <div class="heading text-center">{{section?.header}}</div>
    <div class="divider d-lg-block d-md-block d-none"></div>
    <div class="row content-wrapper">
      <div class="col-lg-6 col-md-6 col-lg-offset-4 col-12 padding-0" *ngFor="let item of section?.data_images">
        <div class="content-box">
          <div class="{{item?.icon_class}}"></div>
          <div class="content">{{item?.text}}</div>
        </div>
      </div>
    </div>
    <div class="row sac-btn">
      <app-sac-button label="Start a Fundraiser" width="320px" height="40px" [redirectSac]="true"></app-sac-button>
    </div>
  </div>
</div>